import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService {
  prequalConfig: any;
  private destroyed$ = new Subject<void>();

  constructor() {
    this.prequalConfig = (window as any).prequalConfig || {};
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
